/**
 * HamburgerTrigger.jsx — Tiny fixed-position button that opens the
 * shared HomeMenu panel. Replaces the old TopBar's inline trigger now
 * that the TopBar has been removed entirely (round 7).
 *
 * #336 — Hidden when `taskbarStore.alwaysVisible()` is true because the
 * Start button in the always-visible Taskbar takes over this role.
 * Shown (top-right) only when the taskbar is in auto-hide mode.
 */
import { Show } from 'solid-js';
import { homeMenu } from '../lib/homeMenuStore.js';
import taskbarStore from '../lib/taskbarStore.js';
import './HamburgerTrigger.css';

export default function HamburgerTrigger() {
  return (
    <Show when={!taskbarStore.alwaysVisible()}>
      <button
        class="v2-hamb v2-launcher__btn"
        type="button"
        title="Home menu"
        aria-label="Open home menu"
        data-hint={'Open the home menu.\nWidgets · Theme · Settings · Account · Layout · Desks'}
        data-hint-level="critical"
        onClick={() => homeMenu.toggle()}
      >
        <span class="v2-hamb__glyph">{homeMenu.open() ? '✖' : '☰'}</span>
      </button>
    </Show>
  );
}
